import globals from "./globals";
import $ from "cash-dom";
import { once, ScrollTween2 as ScrollTween } from "Utilities";

const layout = (function () {
    /**
     * Initialize Scrollable Video instances
     */
    $(document).ready(function () {
        if ($(".layout-scrollable-video").length) {
            if (globals.debug) console.log("layout-scrollable-video initialized");
            var scrollableVideos = [];
            $(".layout-scrollable-video").each(function () {
                var el = $(this)[0];
                var video = $(el).find("video")[0];
                var src = (src = video.currentSrc || video.src);
                var canvasMode = false;

                if (canvasMode) {
                    var canvas = $(el).find(".video-canvas")[0];
                    var ctx = canvas.getContext("2d");
                    video.currentTime = 0;
                    ctx.drawImage(video, 0, 0);
                    setTimeout(function () {
                        console.log("loadedmetadata");
                        ctx.drawImage(video, 0, 0);
                    }, 100);
                }

                scrollableVideos.push(
                    new ScrollTween({
                        element: el,
                        from: "top-top",
                        to: "bottom-bottom",
                        callback: function (_n, _el) {
                            if (isFinite(video.duration * _n)) {
                                // video.pause();
                                // frameNumber = (_n / 11) * 100 - 1;
                                // video.currentTime = frameNumber;
                                video.currentTime = _n * video.duration;

                                if (canvasMode) {
                                    ctx.drawImage(video, 0, 0);
                                }
                                // ctx.drawImage(video, 0, 0);
                                // ctx.drawImage(video, 0, 0);
                                // ctx.drawImage(video, sx, sy, sWidth, sHeight, dx, dy, dWidth, dHeight);
                            }
                        },
                    })
                );

                once(document.documentElement, "touchstart", function (e) {
                    video.play();
                    video.pause();
                });

                setTimeout(function () {
                    if (window["fetch"]) {
                        fetch(src)
                            .then(function (response) {
                                return response.blob();
                            })
                            .then(function (response) {
                                var blobURL = URL.createObjectURL(response);
                                var t = video.currentTime;
                                once(document.documentElement, "touchstart", function (e) {
                                    video.setAttribute("src", blobURL);
                                    video.currentTime = t + 0.01;
                                });
                            });
                    }
                }, 0);
            });
        }
    });
})();

export default layout;
